import packageJson from "../../package.json"
const VERSION = {
  PROJECT_VERSION: packageJson.version,
} as const
export default VERSION
